import moment, { MomentInput } from 'moment';
import { localize } from '../components/turboLive/utils';
import { TURBO_LIVE_ROOT_PATH } from './routing';

const DATE_FORMAT = 'D.M.YYYY';

const formatDate = date => moment(date)?.format(DATE_FORMAT);

// nahradi specialne znaky, ale ponecha slovenske znaky s diakritickym znamienkom (š, č,..)
const replaceSpecialCharacters = (string = '') =>
    string.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}\[\]\\\/\s]/g, '_').replace(/_+/g, '_');

export const getSportEventName = ({ home, away }: { home: string; away?: string }) =>
    `${home}${away ? ` vs ${away}` : ''}`;

const getSportEventUrlDescription = (date: string = '', event: string = '') =>
    (date ? date + '-' : '') + replaceSpecialCharacters(event);

export const sportEventName = sportEvent => {
    const participants = sportEvent.participants;
    const home = participants?.[0] || (sportEvent.getIn && sportEvent.getIn(['participants', 0]));
    const away = participants?.[1] || (sportEvent.getIn && sportEvent.getIn(['participants', 1])) || null;
    return getSportEventName({ home, away });
};

const liveSportEventName = sportEvent => {
    const home = sportEvent.getIn(['opponents', 'home']);
    const away = sportEvent.getIn(['opponents', 'away']);
    return getSportEventName({ home, away });
};

export const oldLiveLiveSportEventName = sportEvent =>
    [sportEvent.getOpponent('home'), sportEvent.getOpponent('away')].filter(Boolean).join(' vs ');

const betSportEventName = bet => {
    const home = bet.participants?.[0] || bet.getIn(['opponents', 0]);
    const away = bet.participants?.[1] || bet.getIn(['opponents', 1]);
    return getSportEventName({ home, away });
};

const searchSportEventName = sportEvent => {
    const opponents = sportEvent.opponents;
    const home = opponents?.[0] || sportEvent.getIn(['opponents', 0]);
    const away = opponents?.[1] || (sportEvent.getIn && sportEvent.getIn(['opponents', 1])) || null;
    return getSportEventName({ home, away });
};

const notificationsSportEventName = sportEvent => {
    const home = sportEvent.opponent1;
    const away = sportEvent.opponent2;
    return getSportEventName({ home, away });
};

export const betslipSportEventName = sportEvent => {
    const home = sportEvent.get('home');
    const away = sportEvent.get('away');
    return getSportEventName({ home, away });
};

const sportEventObjectName = sportEvent => {
    const home = sportEvent.opponents?.home;
    const away = sportEvent.opponents?.away;
    return getSportEventName({ home, away });
};

const sportEventObjectNameLocalized = sportEvent => {
    const home = localize(sportEvent.home);
    const away = localize(sportEvent.away);
    return getSportEventName({ home, away });
};

const sportEventStartDate = sportEvent => formatDate(sportEvent.expiration || sportEvent.get('expirationTime'));
const liveSportEventStartDate = sportEvent => formatDate(sportEvent.get('start'));
const betSportEventStartDate = sportEvent => formatDate(sportEvent.get('expirationDate'));
const betslipSportEventStartDate = sportEvent => formatDate(moment(sportEvent.get('expiration'), 'DD.MM HH:mm'));
const sportEventObjectStartDate = sportEvent => formatDate(sportEvent.start || sportEvent.startTime);
const notificationsEventObjectStartDate = sportEvent => formatDate(sportEvent.startDate);

export const sportEventUrlDescription = sportEvent =>
    getSportEventUrlDescription(sportEventStartDate(sportEvent), sportEventName(sportEvent));

export const liveSportEventUrlDescription = sportEvent =>
    getSportEventUrlDescription(liveSportEventStartDate(sportEvent), liveSportEventName(sportEvent));

export const betSportEventUrlDescription = bet =>
    getSportEventUrlDescription(betSportEventStartDate(bet), betSportEventName(bet));

export const betslipSportEventUrlDescription = sportEvent =>
    getSportEventUrlDescription(betslipSportEventStartDate(sportEvent), betslipSportEventName(sportEvent));

export const sportEventObjectUrlDescription = sportEvent =>
    getSportEventUrlDescription(sportEventObjectStartDate(sportEvent), sportEventObjectName(sportEvent));

export const sportEventLocalizedObjectUrlDescription = sportEvent =>
    getSportEventUrlDescription(sportEventObjectStartDate(sportEvent), sportEventObjectNameLocalized(sportEvent));

export const niketvEventObjectUrlDescription = sportEvent =>
    getSportEventUrlDescription('', betslipSportEventName(sportEvent));

export const searchEventObjectUrlDescription = sportEvent =>
    getSportEventUrlDescription('', searchSportEventName(sportEvent));

export const notificationsEventObjectUrlDescription = sportEvent =>
    getSportEventUrlDescription(notificationsEventObjectStartDate(sportEvent), notificationsSportEventName(sportEvent));

export const n1SportEventInfo = sportEvent => ({
    sport: sportEvent.get('sportName'),
    tournament: sportEvent.get('tournamentName'),
    participants: sportEventName(sportEvent)
});

export const eventUrlDescription = ({ date, home, away }: { date: MomentInput; home: string; away?: string }) => {
    const _date = moment(date).format(DATE_FORMAT);
    const _opponents = getSportEventName({ home, away });
    return getSportEventUrlDescription(_date, _opponents);
};

export const niketvDetailMetaDescription = ({ date, title }: { date: MomentInput; title: string }) => {
    const _date = moment(date).format(DATE_FORMAT);
    return getSportEventUrlDescription(_date, title);
};

export const createTlvDetailLink = ({ sportCode, matchId }: { sportCode; matchId: string }) =>
    TURBO_LIVE_ROOT_PATH + '/' + sportCode + '/' + matchId;
